import {
  COMPANY_RECENT_ACTIVITY_LIST,
  COMPANY_RECENT_ACTIVITY_LIST_SUCCESS,
  COMPANY_RECENT_ACTIVITY_LIST_FAILURE,
} from "./actionType";

const initialData = {
  companyRecentActivityList: [],
  companyRecentActivityListError: [],
  companyRecentActivityLoading: false,
};

const CompanyRecentActivity = (state = initialData, action) => {
  switch (action.type) {
    case COMPANY_RECENT_ACTIVITY_LIST:
      return {
        ...state,
        companyRecentActivityLoading: true,
      };
    case COMPANY_RECENT_ACTIVITY_LIST_SUCCESS:
      return {
        ...state,
        companyRecentActivityList: action.payload,
        companyRecentActivityLoading: false,
      };
    case COMPANY_RECENT_ACTIVITY_LIST_FAILURE:
      return {
        ...state,
        companyRecentActivityListError: action.payload,
        companyRecentActivityLoading: false,
      };
    default:
      return state;
  }
};

export default CompanyRecentActivity;
